import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_HEALTHCARE_PROVIDER } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getSpecificPhysician = createAsyncThunk(
  "healthcareProviders/get-specific-physician",
  async (data) => {
    try {
      const api = useAxios();

      const response = await api.get(URL_HEALTHCARE_PROVIDER + "/" + data.id);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getSpecificPhysician };
